import { Grid, Typography } from '@mui/material';

import { FormFieldReadOnlyValue } from '../../../../../common';
import InformationSectionCard from './InformationSectionCard';

import type { AssignmentCardProps } from './types';

export default function AssignmentCard({
  title,
  emptyMessage,
  entries,
  errorMessage,
}: AssignmentCardProps) {
  let content;
  if (errorMessage) {
    content = <Typography color="error">{errorMessage}</Typography>;
  } else if (entries.length === 0) {
    content = <Typography color="text.secondary">{emptyMessage}</Typography>;
  } else {
    content = entries.map((entry) => (
      <Grid container spacing={2} key={entry.id}>
        <Grid item xs={8}>
          <FormFieldReadOnlyValue label="Name" value={entry.name} />
        </Grid>
        <Grid item xs={4}>
          <FormFieldReadOnlyValue label="Role" value={entry.role} />
        </Grid>
      </Grid>
    ));
  }

  return <InformationSectionCard title={title}>{content}</InformationSectionCard>;
}
